import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/Profile/Profile.js
const Profile = createSectionForm({
  icon: "user-line",
  title: "Profile",
  fields: [{ name: "title", label: "Heading", placeholder: "Profile" }],
});

export default Profile;
